import { render, staticRenderFns } from "./DragNDropRelaunch.vue?vue&type=template&id=1d6eac98&scoped=true&"
import script from "./DragNDropRelaunch.vue?vue&type=script&lang=js&"
export * from "./DragNDropRelaunch.vue?vue&type=script&lang=js&"
import style0 from "./DragNDropRelaunch.vue?vue&type=style&index=0&id=1d6eac98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6eac98",
  null
  
)

component.options.__file = "DragNDropRelaunch.vue"
export default component.exports